import { ref } from "vue-demi";

const loadingInstances = ref(0);
const isLoading = ref(false);

export {
  loadingInstances,
  isLoading
}
